module.exports = {
  language: {
    name: 'English'
  },
  login:{
    userNameInputError:"Please enter your account",
    passwordInputError:"Please enter your password",
    userNameError:'user name does not exist',
    passwordError:'Password error, please re-enter',
    forbidden:"This account has been disabled"
  },
  top:{
    myOrder:'MyOrder',
    accountDetails:'Details',
    changePassword:'ChangePassword',
    logOut:'LogOut',
    logOutTips:"Are you sure to log out?",
    newPassword:'Password',
    newPassword1:'Please enter your password',
    confirmPassword:'ConfirmPassword',
    confirmPassword1:'Please enter your password again',
    passwordTip:'* 8-16 chars with upper/lowercase/numbers.',
    updatePwd:'Consistent old and new passwords',
    updatePwd1:'Old password verification failed',
    resetPassword:"Reset Password",
    valPhoneTips:"Please enter your phone number",
    valPhoneTips1:"Please enter the correct phone number",
    valPhoneTips2:"The phone number is not registered",
  },
  user: {
    logTitle:'Online order system',
    logTitle1:'System backend management platform',
    login:'Login',
    userInfo:'AccountInfo',
    editAccountInfor:'Edit account information',
    register:'Register',
    loginUsername:'please input email or phone',
    placeholder:'Please enter your account/phone',
    placeholder1:'Please enter your password',
    rememberPassword:'RememberPassword',
    forgotPassword:'ForgotPassword',
    regUser:'Haven\'t registered an account yet',
    createAccount:'CreateAccount',
  },
  register:{
    registration:'Registration',
    existingAccount:'Existing Account',
    LoginNow:'Log In Now',
    userName:'UserName',
    userName1:'Please enter your username',
    phone:'Phone',
    phone1:'Please enter your phone number',
    fullName:'FullName',
    fullName1:'Please enter your name',
    sendCode:'Send',
    inputCode:'Please enter the verification code',
    codeError:"Verification code error",
    unitName:'UnitName',
    unitName1:'Please enter your company name',
    password:'Password',
    password1:'Please enter your password',
    password2:"The two passwords entered do not match",
    initPassword:'OriginalPassword',
    initPassword1:'Please enter your original password',
    confirmPassword:'ConfirmPassword',
    confirmPassword1:'Please enter your password again',
    email:'Email',
    email1:'Please enter your email address',
    registerSuccess:"Login was successful",
    registerError:"Registration failed, username already exists",
    registerError1:"Registration failed, the phone number has already been registered",
    registerError2:"It is prohibited to enter your phone number as your username",
  },
  order:{
    orderId:'OrderID',
    orderId1:'Please enter the order number',
    orderCreated:'OrderCreated',
    orderType:'OrderType',
    orderStatus:'OrderStatus',
    designName:'DesignName',
    designName1:'Please enter a design name',
    designCategory:'DesignCategory',
    productService:"设计服务",
    query:'query',
    resetting:'Resetting',
    operate:'Operate',
    details:'Details',
    cancellationOrder:'Cancel'
  },
  orderDetail:{
    orderDetailLabel:"Order Details",
    orderingInformation:"Ordering Information",
    siteInformation:"Site Information",
    ReceivingInformation:"Receiving Information",
    designResults:"Design Results",
    manufacturerRemarks:"Manufacturer's remarks"
  },
  product: {
    ngName:'NGSure™ Custom',
    auName:'Augury™ Custom',
    ngContent:'NGSure™ is a validation design tool for low frequency alleles after NGS tests, and can also be applied on the scenarios of trace mutations directly such as liquid biopsy. Testing services or reagent kits is optional for most cases.',
    auContent:'Augury™ can provide customized assay for the detection of various genomic markers with ultra high sensitivity. Based on innovative algorithm and molecular technology, Augury™ NGS Panels can cover whole exons or hotspot of interest, including CNVs, Indels, SNVs, etc.',
    customizedProducts:'Customized Products',
    cp:"Commit",
    cp1:"de novo",
    customizedProducts1:"NGSure™ design order by specify any variation loci throughout the genome.",
    customizedProducts2:'All we need is the description of one or more variations, alternatively, the genomic locations.',
    customizeNow:'Customize Now',
    catalogProducts:'Catalog Products',
    catalogProducts1:'Select from catalog for shorter delivery time. \n' +
      '\n' +
      'The variation sites have been qualified by standard materials or real samples with known limit of detection (LOD), among which we might deliver kits or perform detection immediately.\n',
    queryNow:'Query Now',
    productAdvantages:'Product Advantages',
    productAdvantages1:'Why use our services?',
    highSense:'High Sensitivity',
    highSense1:'LoD is up to 0.1%~0.01% VAF, depend on various platforms.',
    highSense2:'Ability of primary quantification, higher accuracy can be reached under NGS platform.',
    comprehensiveAndFast:'Flexible and Fast',
    comprehensiveAndFast1:'Handle various kind of mutaions like SNVs and indels FAST and EASY.',
    comprehensiveAndFast2:'Compatible with various sample types, such as FFPE, fresh tissue, blood, etc.',
    platformFlexibility:'Variable Platforms',
    platformFlexibility1:'Directly docked with Sanger sequencing, bring whom unprecedented sensitivity.',
    platformFlexibility2:'Embed with probe qPCR to achieve multiplex detection and more rapid and precise performance.',
    technicalCorePrinciples:'Technical Core Principles',
    technicalCorePrinciples1:'Watching the video helps you better understand the core principles of our technology',
    technicalCorePrinciples2:'Blocker Displacement Amplification (BDA) technology selectively suppresses the amplification of wild-type DNA sequences during the PCR process, resulting in an increase of over 1000 times in the enrichment efficiency of mutated sequences compared to the former, making it possible for conventional techniques such as Sanger sequencing to detect low-frequency mutations.',
    clickToPlayTheVideo:'Click to play the video',
    frequentlyAskedQuestion:'Frequently Asked Question',
    frequentlyAskedQuestion1:'Here you can have a comprehensive view of the design service content and learn how to use them',
    collapse1:'What are the delivery methods?',
    collapse1Content:'',
    collapse2:'What does a kit include?',
    collapse2Content:'',
    collapse3:'Minimum DNA Input Requirements',
    collapse3Content:'',
    collapse4:'PCR duration requirements?',
    collapse4Content:'',
    collapse5:'How many mutations can a kit detect?',
    collapse5Content:'',
    collapse6:'What types of mutations can be detected?',
    collapse6Content:'',
    collapse7:'What are the equipment requirements?',
    collapse7Content:'',
    collapse8:'Sanger sequencing poses difficulties in detecting low VAF mutations. How do you ensure NGSure ™ Is the platform\'s data reliable?',
    collapse8Content:'',
    startYourCustomDesign:'Start your custom design',
    auIndex1:'Based on the unique SADDLE algorithm and QASeq technology from NuProbe, August™ aims to provide highly sensitive detection assay for various genomic markers, which is applicable to liquid biopsy, genetic detection, infectious diseases detection, drug development and other fields.',
    excellentMultiplePerformance:'Excellent multplex performance',
    excellentMultiplePerformance1:'Over 1000 amplicons per panel.',
    cnvHighPrecisionQuantification:'High-precision CNV quantification',
    cnvHighPrecisionQuantification1:'Up to 5% (equivalent ploidy=2.05/1.95) LoD for CNVs, applicable for liquid biopsy.',
    multipleBiomarkerCoExamination:'Comprehensive panel design',
    multipleBiomarkerCoExamination1:'All-in-one detection of various biomarker, such as SNVs, indels, CNVs and fusions.',
    flexibleSampleTypes:'Flexible Sample Types',
    flexibleSampleTypes1:'Suitable for cfDNA, FFPE, etc., even the tumor cell percentage of tissue is lower than 10%.',
    newDAndClinicalTrials:'Drug discovery and clinical trials',
    newDAndClinicalTrials1:'Assist in target discovery, research of biomarkers or alternative clinical endpoint. Deep cooperation through CLIA&CAP certified laboratories.',
    qASeq:'QASeq technology can perform ultra sensitive detection of copy number variation and mutation simultaneously with a lower sample input. By using the unique primer design algorithm SADDLE to suppress the formation of primer dimers in multiple PCR reactions, QASeq can cover a wider range of target regions, thereby improving quantitative accuracy.',
    applicationCases:'Application Cases',
    applicationCases1:'Detailed explanation of practical application cases, for reference only',
    augury:'AUGURY ™ Development and validation of NGS PANEL for breast cancer',
    auguryContent:'Using August ™ The platform constructs an ultra sensitive NGS panel to detect and quantify copy number variations of 18 breast cancer related genes and hot spot mutations of 14 genes.',
    detail:'Detail',
    catalogProductList:'Catalog Product List',
    geneSymbol:'GeneSymbol',
    geneSymbol1:'Please enter a gene name',
    variantDescribe:'VariantDescribe',
    variantDescribe1:'Please enter a variant name',
    sangerPlatform:'Sanger Platform',
    qpcrPlatform:'QPCR Platform',
    place:'place',
  },
  createOrder:{
    designServices:'DesignService',
    designSContent:"Using a first-generation sequencing platform to detect mutated sequences amplified by BDA",
    designSContent1:"Combining probe qPCR and BDA technology, using real-time fluorescence quantitative PCR instrument to detect known mutation sites theoretically has a lower detection limit",
    designSContent2:"If the point contains areas that require detection of copy number variation, please check QASeq CNV",
    productType:'ProductType',
    productType1:'Please select a product type',
    Kit:"Kit",
    KitWEVerification:"Verified",
    testingService:"Service",
    addressLabel:'Address',
    consigneeLabel:'Name',
    consigneePhoneLabel:'Phone',
    address:'Please enter the recipient\'s address',
    consignee:'Please enter the recipient\'s name',
    consigneePhone:'Please enter the recipient\'s phone number',
    saveDefaultAddress:"Save as default address",
    submit:'Submit',
    productName:"ProductName",
    orderType:"OrderType",
    orderTypeContent1:"Customed",
    orderTypeContent2:"Catalog",
    orderTypeContent3:"In stock",
    designName:"Design Name",
    designName1:"Please enter a design name",
    sampleType:"SampleType",
    sampleType1:"gDNA-FFPE ",
    sampleType1Tips:"There may be damage mutations and shorter average lengths in the gDNA of this type of sample",
    sampleType2:"cfDNA",
    sampleType3:"gDNA",
    orderDescription:"OrderDescription",
    orderDescription1:"Please enter order description information, such as lower limit of mutation site detection (LoD) requirements, sample type details, etc.",
    orderDescription2:"Please enter order description information, such as sequencing platform, lower limit of detection (LoD) requirements, disease type, DNA sample starting size, etc.",
    back:"Back",
    next:"Next",
    optionDesignServer:"Please select a design service",
    optionSampleType:"Please select a sample type",
    targets:'Targets',
    targets1:"Please enter the detection site",
    manualEntry:"ManualEntry",
    fileUpload:"Upload",
    downloadTemplate:"Download Template",
    clickUpload:"upload",
    templateExample:"Template Example",
    targetsDesc:"Description of detection site format",
    lookAll:"More",
    OrderSubmitted:"Order Submitted",
    OrderSubmitted1:"The backend business personnel will contact you as soon as possible. You can view the progress of order processing at any time from the \"My Order List\".",
    nextOrder:"Next Order",
    myOrderList:"My Order List",
  },
  orderStatusDict:{
    orderStatus1:"Submited",
    orderStatus2:"Designing",
    orderStatus3:"Producting",
    orderStatus4:"Testing",
    orderStatus5:"Finished",
    orderStatus6:"Closed",
  },
  orderStatusDictList:{
    orderStatus1:"Submited",
    orderStatus2:"Designing",
    orderStatus3:"Designed",
    orderStatus4:"Reviewed",
    orderStatus5:"Producting",
    orderStatus6:"Productioned",
    orderStatus7:"Testing",
    orderStatus8:"Testinged",
    orderStatus9:"Closed",
    orderStatus10:"Ready",
    orderStatus11:"Finished",
  },
  index:{
    welcome:'Welcome to NuProbe',
    yueer:'Online Product Customization Service',
    about:'About NuProbe'
  },
  footer:{
    yeerGene:'NuProbe',
    aboutUs:'About Us',
    officialWebsite:"Official Website",
    productsServices:'Products and Services',
    technicalSupport:'Technical Support',
    contactUs:'Contact Us',
    law:'Law',
    privacyPolicy:'Privacy Policy',
    supplementaryTermsConditions:'Supplementary Terms and Conditions'
  },
  operate:{
    edit:'Edit',
    save:'Save',
    cancel:'Cancel',
    determine:'Determine',
    updateSuccess:'Successfully Modified',
    pleaseSelect:"Please Select",
    startDate:"Start Date",
    endDate:"End Date",
    cancelOrderContent:"Please confirm whether to cancel the order?",
    cancelOrderTip:"Order cancelled",
    copyOrder:"Copy Order",
    tips:"prompt",
    copyOrderTip:"The order has been copied. Do you want to jump to the Create Order page?",
    backList:"Return to List",
    backPage:'Back',
    resetPasswordTips:"Password modification successful, please confirm to go to the login page and log in again",
    resetPasswordTips1:"Please confirm to log out and log in again"
  },
  loading:{
    loadingText:"loading..."
  },
  targetsErrorTip:{
    rows:"Line ",
    label:"Detection site format error",
    labelO:"Only one site can be entered in a row",
    geneError:"Gene name error",
    geneError1:"Please enter a gene name",
    chromosomeError:"Unknown chromosome name",
    locationError:"Site location error",
    wildTypeSequenceError:"Wild type sequence error",
    mutationSequenceError:"Mutation sequence error",
    error1:"Format Error",
    error2:"Target",
    error3:"Error"
  }
}



// WEBPACK FOOTER //
// ./src/language/en.js